import {buildAsyncActionsCreator, createAsyncActionExecutor} from '../asyncUtils';
import {ModelDisplayViewersActions} from './types';
import {requestModelDisplayViewers} from './api';

const modelDisplayViewersLoadActionsCreator = buildAsyncActionsCreator(ModelDisplayViewersActions.FETCH);
export const modelDisplayViewersLoad = createAsyncActionExecutor(
  modelDisplayViewersLoadActionsCreator,
  requestModelDisplayViewers,
);
